import { FunctionComponent } from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import {
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Skeleton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Checkbox,
} from "@chakra-ui/react";
import { MdMoreVert } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { EmptyState } from "../EmptyState";

type Props = {
  heading: string[];
  body: object[];
  isAction?: boolean;
  handleAction?: (selectedRow?: any) => void;
  isFetching?: boolean;
  data?: any;
  action?: "view" | "more";
  menuList?: {
    label: string;
    isHideMenu?: boolean;
    menuAction: (id: any) => void;
  }[];
  handleSelectItem?: any;
  checkedItems?: any;
  isShowCheckedItems?: boolean;
  checkedPages?: any;
};

export const CustomTable: FunctionComponent<Props> = ({
  heading,
  body,
  isAction,
  handleAction,
  isFetching,
  action,
  menuList,
  handleSelectItem,
  checkedItems,
  isShowCheckedItems = false,
  checkedPages,
}) => {
  const { search } = useLocation();
  const queryParam = new URLSearchParams(search);
  const pageNum = queryParam.get("page");

  // const allChecked = checkedItems?.includes("all");
  const allChecked = checkedPages?.includes(Number(pageNum));
  // const isIndeterminate = checkedItems?.some(Boolean) && !allChecked;
  const isIndeterminate = !!allChecked;

  console.log(
    allChecked,
    "??",
    isIndeterminate,
    "@@",
    checkedItems,
    checkedPages,
  );

  console.log(search, "loc", queryParam.get("page"), body);

  return (
    <TableContainer>
      <Table>
        <Thead bg={"#F0F0FA"} py={3}>
          <Tr>
            {isShowCheckedItems && (
              <Th>
                <Checkbox
                  size={"sm"}
                  isChecked={allChecked}
                  isIndeterminate={isIndeterminate}
                  onChange={(e: any) => handleSelectItem(e, body, pageNum)}
                />
              </Th>
            )}
            {heading?.map((title: string) => (
              <Th
                fontSize={"12px"}
                fontWeight={700}
                paddingStart={5}
                py={4}
                textTransform={"capitalize"}
                color="#000"
                key={title}
              >
                {title}
              </Th>
            ))}
            {isAction && (
              <Th
                fontSize={"12px"}
                fontWeight={700}
                paddingStart={5}
                py={4}
                textTransform={"capitalize"}
                color="#000"
              >
                Action
              </Th>
            )}
          </Tr>
        </Thead>
        <Tbody>
          {body?.length === 0 ? (
            <Tr textAlign={"center"}>
              <Td textAlign={"center"} colSpan={7} height={"300px"}>
                <EmptyState height="400px" label="Record not found" />
              </Td>
            </Tr>
          ) : (
            body?.map((role: any, index: number) => (
              <Tr
                // bg={index % 2 === 0 ? "secondary" : "unset"}
                color="#0B0A0A"
                key={index}
              >
                {isShowCheckedItems && (
                  <Td>
                    <Checkbox
                      size={"sm"}
                      onChange={(e: any) => handleSelectItem(e, role, pageNum)}
                      isDisabled={role.row_disabled}
                      isChecked={
                        role.row_disabled
                          ? false
                          : // : checkedItems.includes("all")
                            //   ? true
                            // : checkedItems?.includes(role.id)
                            checkedItems?.find(
                                (item: any) => item.id === role.id,
                              )
                            ? true
                            : false
                      }
                    />
                  </Td>
                )}
                {heading.map((title: string) => (
                  <Td
                    fontSize={"12px"}
                    fontWeight={400}
                    paddingStart={5}
                    paddingTop={4}
                    paddingBottom={4}
                    key={title}
                    textTransform={"capitalize"}
                    color={role.row_disabled ? "#00000045" : "unset"}
                    width={title === "" ? "2px" : "unset"}
                    paddingRight={title === "" ? "0px" : ""}
                  >
                    <Skeleton isLoaded={!isFetching} fadeDuration={1}>
                      {role[title]}
                    </Skeleton>
                  </Td>
                ))}
                {isAction && (
                  <Td
                    fontSize={"12px"}
                    fontWeight={400}
                    paddingStart={5}
                    paddingTop={4}
                    paddingBottom={4}
                    cursor={"pointer"}
                    onClick={() => handleAction(role)}
                    pointerEvents={role.row_disabled ? "none" : "unset"}
                    color={role.row_disabled ? "#00000045" : "unset"}
                  >
                    <Skeleton
                      isLoaded={!isFetching}
                      fadeDuration={1}
                      display={"flex"}
                      gap={1}
                      alignItems={"center"}
                    >
                      {action === "view" ? (
                        <>
                          <MdOutlineRemoveRedEye fontSize={"14px"} /> View
                        </>
                      ) : (
                        <>
                          <Menu>
                            <MenuButton>
                              <MdMoreVert fontSize={"14px"} />
                            </MenuButton>
                            {menuList.length !== 0 && (
                              <MenuList py={0}>
                                {menuList.map(
                                  (menu: {
                                    label: string;
                                    isHideMenu?: boolean;
                                    menuAction: (id: any) => void;
                                  }) => (
                                    <>
                                      {!menu.isHideMenu && (
                                        <MenuItem
                                          onClick={(id: any) =>
                                            menu.menuAction(id)
                                          }
                                          py={3}
                                        >
                                          {menu.label}
                                        </MenuItem>
                                      )}
                                    </>
                                  ),
                                )}
                              </MenuList>
                            )}
                          </Menu>
                        </>
                      )}
                    </Skeleton>
                  </Td>
                )}
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
